import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FeatherModule } from 'angular-feather';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { Configuration } from '../../Configuration/configuration';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { MaterialModule } from '../../material.module';
import { UsermanagementService } from '../../services/apps/usermanagement/usermanagement.service';

@Component({
  selector: 'app-forgot-password',
  imports: [MaterialModule, TablerIconsModule, FeatherModule, CommonModule, RouterLink, ReactiveFormsModule, FormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  providers: [
    { provide: Configuration, useValue: new Configuration() } // or useClass, useFactory
  ]
})
export class ForgotPasswordComponent implements OnInit {
  _disableSend: boolean = false;
  year: any; nextyear: any;
  constructor(private toastr: ToastrService, private router: Router, private route: ActivatedRoute, private _UsermanagementService: UsermanagementService, private configService: ConfigurationService) {

  }
  ngOnInit(): void {
    debugger
    this.CreateEmailForm();
    var curentdate = new Date();
    var y = curentdate.getFullYear();
    this.year = y
    this.nextyear = y;
  }
  EmailForm: FormGroup
  CreateEmailForm() {
    this.EmailForm = new FormGroup({
      EmailId: new FormControl(null, {
        validators: Validators.compose([Validators.required, Validators.pattern(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        )]), updateOn: 'blur'
      })
    })
  }
  Clear() {
    this.EmailForm.reset();
  }
  Send() {
    debugger
    this.EmailForm.markAllAsTouched();
    if (this.EmailForm.valid) {
      this._disableSend = true
      var Email = this.EmailForm.controls["EmailId"].value
      this._UsermanagementService.ForgotPassword(Email).subscribe((data: string) => {
        this._disableSend = false
          if (data == "Mail sent successfully.") {
            this.toastr.success(`Reset password email has been send to ${Email}`)
            setTimeout(() => {
              localStorage.clear();
              sessionStorage.clear();
              var url = this.configService.get().url
              window.location.href = url
            }, 3000)
          } else {
            this.toastr.error(data)
          }
      }, (error: HttpErrorResponse) => {
        this._disableSend = false
        this.toastr.error(error.statusText)
      })
    }
  }
}
